import React, { useEffect, useState } from "react";
import ModalB from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import "./modal.css";

const Modal = (props) => {
  const [tituloModal, setTituloModal] = useState(props.titulo);

  useEffect(() => {
    setTituloModal(props.titulo);
  }, [props]);

  const handleModal = () => props.toggleModal();
  const temFooter = Boolean(props.to || props.footerContent);

  return (
    <>
      <ModalB
        show={props.show}
        onHide={handleModal}
        size={props.size || undefined}
        dialogClassName={props.dialogClassName}
      >
        <ModalB.Header closeButton>
          <ModalB.Title className="titulo-modal">{tituloModal}</ModalB.Title>
        </ModalB.Header>
        <ModalB.Body>{props.children}</ModalB.Body>
        {temFooter ? (
          <ModalB.Footer className={props.footerClassName}>
            {props.footerContent}
            {props.to ? (
              <Link to={props.to} onClick={handleModal} className="link-padrao">
                {props.labelTo}
              </Link>
            ) : null}
          </ModalB.Footer>
        ) : null}
      </ModalB>
    </>
  );
};

export default Modal;
